export const wrapper =
  'bg-uiBg overflow-hidden rounded-10 shadow-card mb-30 w-full';
export const content = 'p-4';
export const header = '';
export const text = 'mt-2 mb-4';
export const icon = 'h-4 w-4 text-primary ml-2';
export const texthover = 'cursor-pointer';
